import React from "react";
import LegoL99DData from "../dataDriven/LegoL99DData";
import managingDiabetesCards from "../dataDriven/managingDiabetesCards";

// Live demo: the data-driven L99D renders the same markup as the hand-authored
// L99D lego, but from a {title, pdf, thumb}[] array (here, the real Managing
// Diabetes manifest). 6 cards => 4 + 2 centered.
function L99DDataComponentCode() {
  return (
    <div>
      <LegoL99DData cards={managingDiabetesCards} />
    </div>
  );
}

export default L99DDataComponentCode;
